import { compose } from "recompose";
import { withTranslator } from "app/decorators";
import AccountForm from "./AccountForm";
import reactForm from "react-form";

export default compose(withTranslator, reactForm())(AccountForm);



// WEBPACK FOOTER //
// ./src/app/components/CheckoutAccount/AccountForm/AccountFormContainer.js